import { PHIVE_RET } from './constants.js';

export default {
    install(app) {
        app.config.globalProperties.$PHIVE_RET = PHIVE_RET;
    }
};